'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./slick/slickcarousel'));
    processInclude(require('./slick/slick'));
});

